import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Header from "../components/header";
import PetalFall from "../components/petal-fall";
import WhatsappCta from "../components/whatsapp-cta";
import { SITE_IMAGES } from "src/config/images";

// ПЕРВЫЙ ЭКРАН.
//
// Цифры компании раньше стояли здесь, внизу экрана. Теперь они вынесены в
// отдельную полосу сразу под первым экраном (sections/about/stats-band.jsx):
// на телефоне четыре числа съедали половину первого экрана и отодвигали
// кнопку заявки за нижний край. Дублировать их в двух местах подряд нельзя,
// поэтому здесь их больше нет.
const Hero = () => {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[85svh] sm:min-h-[86vh] flex flex-col">
      {/* Фото главного экрана — меняется в src/config/images.js (ключ hero) */}
      <img
        src={SITE_IMAGES.hero}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/*
        ЗАТЕМНЕНИЕ В ДВА СЛОЯ.
        Раньше был один градиент сверху вниз, и в середине кадра он давал
        всего 40% плотности. Ровно туда на телефоне попадал подзаголовок —
        светло-розовый текст ложился на подсвеченное небо и не читался.
        Теперь плотность стоит там, где текст: узкая вуаль сверху под меню
        и широкая снизу под заголовок, подзаголовок и кнопки. Середина кадра
        остаётся открытой — фотография не превращается в серую заливку.
      */}
      <div
        aria-hidden="true"
        className="absolute inset-x-0 top-0 h-44 bg-gradient-to-b from-kj-dark/75 to-transparent"
      />
      {/*
        ВУАЛЬ СЛЕВА — ПОД КОЛОНКОЙ ТЕКСТА.
        Весь текст первого экрана прижат к левому краю, а самое светлое место
        кадра — небо над Фудзи в центре. Затемнять ради двух строк весь кадр
        неправильно: гора и сакура ради этого и стоят на первом экране.
        Поэтому вуаль горизонтальная: плотная у левого края, где надстрочник
        «Discover Japan» и подзаголовок, и полностью прозрачная к центру.
        Золотая надпись 12 px на светлом небе давала контраст около 1.2:1 —
        то есть не читалась вовсе; на этой подложке она снова видна.
      */}
      <div
        aria-hidden="true"
        className="absolute inset-y-0 left-0 w-[70%] lg:w-[58%] bg-gradient-to-r from-kj-dark/85 via-kj-dark/40 to-transparent"
      />
      <div
        aria-hidden="true"
        className="absolute inset-x-0 bottom-0 h-[72%] bg-gradient-to-t from-kj-dark via-kj-dark/70 to-transparent"
      />

      {/* Листопад поверх фото, но под текстом: весной лепестки сакуры,
          осенью — кленовые листья. Сезон переключается кнопкой в шапке. */}
      <PetalFall />

      <div className="relative z-10 max-w-[1526px] w-full mx-auto px-4 flex flex-col flex-1">
        <Header />

        <div className="flex-1 flex flex-col justify-end pb-6 pt-16 sm:pb-10 sm:pt-24">
          <p className="on-photo text-kj-gold text-xs sm:text-sm font-extrabold tracking-[0.28em] uppercase mb-4 sm:mb-5">
            {t("main.hero.eyebrow")}
          </p>
          <h1 className="on-photo text-4xl sm:text-6xl lg:text-7xl font-extrabold uppercase leading-[0.96] tracking-tight text-kj-ink max-w-[18ch] text-balance">
            {t("main.hero.title")}
          </h1>
          <p className="on-photo mt-4 sm:mt-6 text-base sm:text-lg text-kj-sub max-w-[52ch] leading-relaxed">
            {t("main.hero.subtitle")}
          </p>

          {/* ЦЕЛЕВОЕ ДЕЙСТВИЕ НА ПЕРВОМ ЭКРАНЕ.
              Перевод для этой кнопки лежал в словарях всех четырёх языков, но
              на странице её не было: человек, которого зацепил заголовок, мог
              только искать глазами мелкую кнопку в шапке. Рядом — спокойный
              второй путь для тех, кто ещё не готов писать: посмотреть туры. */}
          <div className="mt-7 sm:mt-9 flex flex-col xs:flex-row items-stretch xs:items-center gap-3">
            <WhatsappCta
              label={t("main.hero.buttonText")}
              withIcon
              className="px-8 bg-kj-gold text-kj-dark hover:bg-kj-gold/90 uppercase tracking-[0.08em] text-sm font-bold rounded-sm"
            />
            <Link
              to="/activities"
              className="inline-flex min-h-[44px] items-center justify-center rounded-sm border border-kj-ink/30 bg-kj-dark/30 px-7 text-sm font-bold uppercase tracking-[0.08em] text-kj-ink backdrop-blur-sm transition-colors hover:border-kj-gold hover:text-kj-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-kj-gold focus-visible:ring-offset-2 focus-visible:ring-offset-kj-dark"
            >
              {t("activities.buttonText")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
